import React from 'react';
import './Blog.css';

function Blog() {
  const blogPosts = [
    {
      title: "Understanding Your Bhagyank: A Deep Dive",
      date: "July 29, 2025",
      author: "TweeLabs",
      content: "<p>Your Bhagyank, or Destiny Number, is a pivotal aspect of numerology...</p><p>It reveals your life's purpose, the lessons you are here to learn, and the path you are destined to follow...</p>"
    },
    {
      title: "The Power of Lucky Numbers in Your Daily Life",
      date: "July 28, 2025",
      author: "TweeLabs",
      content: "<p>Lucky numbers have fascinated humanity for centuries, believed to bring good fortune and positive energy...</p><p>Discover how to identify your personal lucky numbers and integrate them into your daily decisions...</p>"
    },
    {
      title: "Astrology and Career: Finding Your True Calling",
      date: "July 27, 2025",
      author: "TweeLabs",
      content: "<p>Astrology offers profound insights into your innate talents and potential career paths...</p><p>By analyzing your birth chart, you can uncover professions that align with your cosmic blueprint...</p>"
    },
  ];

  return (
    <div className="blog-page container my-8">
      <h1 className="text-center text-primary">Our Blog</h1>
      <p className="text-center">Insights and articles on Astrology, Numerology, and more.</p>

      <div className="blog-posts-grid">
        {blogPosts.map((post, index) => (
          <div key={index} className="blog-post-card shadow-md rounded-lg p-6">
            <h2>{post.title}</h2>
            <p className="post-meta">By {post.author} on {post.date}</p>
            <div className="post-content" dangerouslySetInnerHTML={{ __html: post.content }} />
            <span className="read-more">Read More</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Blog;
